import TableCellText from "ds/components/Table/Row/CellText";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { pluralizeNext } from "shared/Pluralize";

import { SpaceDetailsAccessEntity } from "./types";

const SpaceDetailsAccessRoleSummaryCell = ({
  item,
  ...cellProps
}: TableSimpleCellProps<SpaceDetailsAccessEntity>) => {
  const roleCount = new Set(item.roleBindings.map((binding) => binding.role.id)).size;
  const label = pluralizeNext(roleCount, "role");

  return (
    <TableSimpleCell {...cellProps}>
      <TableCellText>{label}</TableCellText>
    </TableSimpleCell>
  );
};

export default SpaceDetailsAccessRoleSummaryCell;
